import { useEffect, useId, useRef, useState } from 'react'

import LabelFloating from './label-floating'

interface Props extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  label: string
  initialValue?: string
  onUpdate?: (arg: string) => void
  tooltip?: string
}

export default function TextArea(props: Props): JSX.Element {
  const { label, initialValue, onUpdate, tooltip, ...inputProps } = props

  const ref = useRef<HTMLTextAreaElement>()
  const uid = useId()

  const [hasFocus, setFocus] = useState(false)
  const [input, setInput] = useState('')
  const [search, setSearch] = useState()

  useEffect(() => {
    setSearch(new URLSearchParams(window.location).get('search'))

    const defVal = new URLSearchParams(search).get(inputProps.name) || (initialValue as string)
    if (defVal) setInput(defVal)

    if (document.hasFocus() && ref.current === document.activeElement) setFocus(true)
  }, [])

  useEffect(() => {
    if (onUpdate) onUpdate(input)
  }, [input])

  return (
    <LabelFloating
      label={label}
      uid={uid}
      hasFocus={hasFocus}
      hasInput={input?.length > 0}
      required={inputProps.required}
      name={inputProps.name}
      tooltip={tooltip}
    >
      <textarea
        ref={ref}
        id={uid}
        defaultValue={input}
        onChange={(event) => setInput(event.target.value)}
        onFocus={() => setFocus(true)}
        onBlur={() => setFocus(false)}
        className="px-3 py-2 text-secondary-800 dark:text-secondary-50 text-lg w-full outline-hidden"
        {...inputProps}
      />
    </LabelFloating>
  )
}
